import axios from "axios";

export const getCertificatiApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/`, {
        params: params
    });
}

export const getCsvCertificatiApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/csv/`, {
        params: params
    });
}

export const getCertificatoByIdApi = (idCertificato, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}`, {
        params: params
    });
}

export const deleteCertificatoApi = (idCertificato, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}`, {
        params: params
    });
}

export const getModuloCertificatoApi = (tipo, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/modulo/${tipo}`, {
        params: params
    });
}

export const getTipiRichiestaCertificatiApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/tipo-certificato/`, {
        params: params
    });
}

export const aggiornaCertificatoApi = (idCertificato, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}`, payload, {
        params: params
    });
}

export const aggiungiCertificatoApi = (idUsr, payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUsr}/certificato/`, payload, {
        params: params
    });
}

export const aggiornaPrivacyCertificatoApi = (idCertificato, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/privacy_cert/`, payload, {
        params: params
    });
}

export const getInfoPagamentoApi = (idCertificato, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/info-pagamento/`, {
        params: params
    });
}

export const aggiungiQuotaCertificatoApi = (idCertificato, payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/quota/`, payload, {
        params: params
    });
}

export const aggiornaQuotaCertificatoApi = (idCertificato, idQuota, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/quota/${idQuota}`, payload, {
        params: params
    });
}

export const getStampaCertificatoApi = (idCertificato, idTipoCertificato, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/stampa/${idTipoCertificato}`, {
        params: params
    });
}

export const getDocumentiFirmatiApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/documento-firmato/`, {
        params: params
    });
}

export const getDocumentoFirmatoApi = (idCertificato, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/documento-firmato/`, {
        params: params
    });
}

export const getDocumentoFirmato2Api = (idCertificato, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/documento-firmato/${idCertificato}`, {
        params: params
    });
}

export const inviaEmailDocumentoFirmatoApi = (idCertificato, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/documento-firmato/email`, {
        params: params
    });
}

export const deleteDocumentoFirmatoApi = (idCertificato, idDocumento, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/documento-firmato/${idDocumento}`, {
        params: params
    });
}

export const aggiornaStatoCertificatoApi = (idCertificato, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/stato/`, payload, {
        params: params
    });
}

export const aggiungiNotaCertificatoApi = (idCertificato, payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/nota/`, payload, {
        params: params
    });
}

export const aggiornaAssegnazioneSegreteriaApi = (idCertificato, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/segreteria/`, payload, {
        params: params
    });
}

export const aggiornaCommissarioCertificatoApi = (idCertificato, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/commissario/`, payload, {
        params: params
    });
}

export const aggiornaDichiarazioneResponsabilitaCertificatoApi = (idCertificato, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/resp-crs/`, payload, {
        params: params
    });
}

export const getRelazioniCertificatoApi = (idCertificato, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/relazione/`, {
        params: params
    });
}

export const getRelazioneCertificatoApi = (idCertificato, idRelazione, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/relazione/${idRelazione}`, {
        params: params
    });
}

export const aggiornaRelazioneCertificatoApi = (idCertificato, idRelazione, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/relazione/${idRelazione}`, payload, {
        params: params
    });
}

export const aggiungiRelazioneCertificatoApi = (idCertificato, payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/relazione/`, payload, {
        params: params
    });
}

export const assegnaCertificatoNuovoSocioApi = (idCertificato, idSocio, payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/nuovo-socio/${idSocio}`, payload, {
        params: params
    });
}

export const aggiungiQuotaTempCertificatoApi = (idCertificato, payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/quota-temp/`, payload, {
        params: params
    });
}

export const impostaUtilizzabilePerCopiaApi = (idCertificato, payload = {}, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/certificato/${idCertificato}/utilizzabile-per-copia/`, payload, {
        params: params
    });
}